import * as React from 'react';
import PropTypes from 'prop-types';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Autocomplete from '@mui/material/Autocomplete';
import useDebounce from '../../../utils/useDebounce';
import { getFeeds } from '../../../redux/feed/actions';

const FeedsAutocomplete = ({
  onSelect,
  value,
  validation,
  ...rest
}) => {
  const dispatch = useDispatch();

  // React state
  const [searchField, setSearchField] = React.useState('');

  // Redux state
  const {
    isFetchingFeeds,
    feeds,
  } = useSelector((state) => state.feed);

  const debouncedSearch = useDebounce(searchField, 500);

  React.useEffect(() => {
    dispatch(getFeeds(0, 10, '&sort=order,asc&sort=name,asc', debouncedSearch));
  }, [debouncedSearch]);

  return (
    <Autocomplete
      id="feed-select-autocomplete"
      onChange={onSelect}
      // disabled={isFetchingFeeds} // For some reason this is closing the options dropdown??
      loading={isFetchingFeeds}
      filterOptions={(x) => x}
      options={[...feeds.content].sort((a, b) => -b.type.localeCompare(a.type))}
      value={value}
      isOptionEqualToValue={(option, valueCompare) => option.id === valueCompare.id}
      groupBy={(option) => option.type}
      getOptionLabel={(option) => option.name}
      {...rest}
      noOptionsText={<>No feed found, you may need to create it in the <a href="/settings/feeds">feed settings page</a>.</>}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Feed"
          placeholder="Type to search for feed..."
          fullWidth
          onChange={(e) => { setSearchField(e.target.value); }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {isFetchingFeeds
                  ? <CircularProgress color="inherit" size={20} />
                  : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          error={!!validation}
          helperText={validation && validation}
        />
      )}
    />
  );
};

FeedsAutocomplete.propTypes = {
  onSelect: PropTypes.func.isRequired,
  value: PropTypes.object,
  validation: PropTypes.string,
};

FeedsAutocomplete.defaultProps = {
  value: null,
  validation: null,
};

export default FeedsAutocomplete;
